export default __webpack_public_path__ + "static/media/divider.cde0ff27.svg";